type AdobeRouteConfig = {
  pageName: string;
  pageType: string;
  siteSection: string;
  eventType: string;
};

const defaultConfig = {
  eventType: 'pageView',
};

export const AdobeRoutesConfig: Record<string, AdobeRouteConfig> = {
  '/sign-in': {
    ...defaultConfig,
    pageName: 'SignIn Page',
    pageType: 'SignIn',
    siteSection: 'SignIn',
  },
  '/dashboard': {
    ...defaultConfig,
    pageName: 'Dashboard Page',
    pageType: 'Dashboard',
    siteSection: 'dashboard',
  },
  '/home/your-plan': {
    ...defaultConfig,
    pageName: 'Your Plan Page',
    pageType: 'Plan',
    siteSection: 'your-plan',
  },
  '/home/benefits': {
    ...defaultConfig,
    pageName: 'Benefits Page',
    pageType: 'Benefits',
    siteSection: 'benefits',
  },
  '/home/plan-documents': {
    ...defaultConfig,
    pageName: 'Plan Documents Page',
    pageType: 'Documents',
    siteSection: 'plan-documents',
  },
  '/home/covered-eligible-members': {
    ...defaultConfig,
    pageName: 'Covered Eligible Members Page',
    pageType: 'Members',
    siteSection: 'covered-eligible-members',
  },
  '/home/member-id-card': {
    ...defaultConfig,
    pageName: 'Member ID Card Page',
    pageType: 'ID Card',
    siteSection: 'member-id-card',
  },
  '/home/enroll-benefits': {
    ...defaultConfig,
    pageName: 'Enroll Benefits Page',
    pageType: 'Enrollment',
    siteSection: 'enroll-benefits',
  },
  '/home/authorizations': {
    ...defaultConfig,
    pageName: 'Authorizations Page',
    pageType: 'Authorizations',
    siteSection: 'authorizations',
  },
  '/home/pay-your-sentara-bill': {
    ...defaultConfig,
    pageName: 'Pay Your Bill Page',
    pageType: 'Billing',
    siteSection: 'pay-your-sentara-bill',
  },
  '/home/medical-claims': {
    ...defaultConfig,
    pageName: 'Medical Claims Page',
    pageType: 'Claims',
    siteSection: 'medical-claims',
  },
  '/home/behavioral-claims': {
    ...defaultConfig,
    pageName: 'Behavioral Claims Page',
    pageType: 'Claims',
    siteSection: 'behavioral-claims',
  },
  '/home/pharmacy-claims': {
    ...defaultConfig,
    pageName: 'Pharmacy Claims Page',
    pageType: 'Claims',
    siteSection: 'pharmacy-claims',
  },
  '/home/costs-calculate': {
    ...defaultConfig,
    pageName: 'Cost Calculator Page',
    pageType: 'Calculator',
    siteSection: 'costs-calculate',
  },
  '/home/virtual-visit-care': {
    ...defaultConfig,
    pageName: 'Virtual Visit Care Page',
    pageType: 'Care',
    siteSection: 'virtual-visit-care',
  },
  '/home/pharmacy-tools': {
    ...defaultConfig,
    pageName: 'Pharmacy Tools Page',
    pageType: 'Pharmacy',
    siteSection: 'pharmacy-tools',
  },
  '/home/contact-us': {
    ...defaultConfig,
    pageName: 'Contact Us Page',
    pageType: 'Contact',
    siteSection: 'contact-us',
  },
  '/home/wellness-programs': {
    ...defaultConfig,
    pageName: 'Wellness Programs Page',
    pageType: 'Wellness',
    siteSection: 'wellness-programs',
  },
  '/reset-password': {
    ...defaultConfig,
    pageName: 'Forgot Password',
    pageType: 'Authentication',
    siteSection: 'forgot-password',
  },
  '/login/forgot-username': {
    ...defaultConfig,
    pageName: 'Forgot Username',
    pageType: 'Authentication',
    siteSection: 'forgot-username',
  },
  '/dr-authorization': {
    ...defaultConfig,
    pageName: 'DR Authorization Page',
    pageType: 'Authorization',
    siteSection: 'dr-authorization',
  },
  '/home/accounts-shared-with-me': {
    ...defaultConfig,
    pageName: 'Accounts Shared With Me Page',
    pageType: 'Authorization',
    siteSection: 'accounts-shared-with-me',
  },
  '/csr-proxy-form': {
    ...defaultConfig,
    pageName: 'CSR Proxy Form Page',
    pageType: 'Proxy',
    siteSection: 'csr-proxy-form',
  },
  '/csr-proxy-success': {
    ...defaultConfig,
    pageName: 'CSR Proxy Success Page',
    pageType: 'Proxy',
    siteSection: 'csr-proxy-success',
  },
  '/account/activation/dr-registration': {
    ...defaultConfig,
    pageName: 'DR Registration Page',
    pageType: 'Registration',
    siteSection: 'dr-registration',
  },
  '/account/activation/dr-child-only-plan': {
    ...defaultConfig,
    pageName: 'DR Child-Only Registration Page',
    pageType: 'Registration',
    siteSection: 'dr-child-only-registration',
  },
  '/proxy-expired-form': {
    ...defaultConfig,
    pageName: 'Proxy Expired Page',
    pageType: 'Proxy',
    siteSection: 'proxy-expired-form',
  },
  '/proxy-register': {
    ...defaultConfig,
    pageName: 'Proxy Register Page',
    pageType: 'Proxy',
    siteSection: 'proxy-register',
  },
  '/proxy-authorization-error': {
    ...defaultConfig,
    pageName: 'Proxy Authorization Error Page',
    pageType: 'Proxy',
    siteSection: 'proxy-authorization-error',
  },
};